import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-twitter",
  "use": "icon-twitter-usage",
  "viewBox": "0 0 200 162.536",
  "content": "<symbol viewBox=\"0 0 200 162.536\" id=\"icon-twitter\">\r\n<g>\r\n\t<path d=\"M200,19.24c-7.358,3.264-15.267,5.469-23.566,6.461c8.471-5.078,14.978-13.119,18.041-22.701\r\n\t\tc-7.929,4.702-16.71,8.117-26.057,9.957C160.934,4.982,150.27,0,138.468,0c-22.66,0-41.033,18.371-41.033,41.031\r\n\t\tc0,3.216,0.363,6.348,1.063,9.351C64.396,48.671,34.161,32.335,13.924,7.51c-3.532,6.06-5.556,13.108-5.556,20.628\r\n\t\tc0,14.236,7.244,26.795,18.254,34.154c-6.726-0.214-13.053-2.059-18.585-5.133c-0.004,0.172-0.004,0.343-0.004,0.517\r\n\t\tc0,19.88,14.144,36.463,32.915,40.234c-3.443,0.938-7.068,1.439-10.81,1.439c-2.644,0-5.215-0.258-7.721-0.736\r\n\t\tc5.222,16.301,20.375,28.165,38.331,28.495c-14.043,11.006-31.735,17.565-50.96,17.565c-3.312,0-6.578-0.194-9.788-0.574\r\n\t\tc18.159,11.643,39.727,18.437,62.899,18.437c75.473,0,116.746-62.524,116.746-116.747c0-1.779-0.041-3.549-0.119-5.309\r\n\t\tC187.543,34.695,194.499,27.469,200,19.24\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/twitter.svg
// module id = ./app/general/svg/twitter.svg
// module chunks = app